import type { CatalogRule } from '@repo/api-codegen';
import { AutomationPropagateMetadataRelationship } from '../../api/types/models/automation/automationPropagateMetadata';
import type { PropagateMetadataSettings } from '../../features/PropagateBlock/types';
import { FILTER_OPTIONS_DIVIDER, FilterOptionType } from '../Filter';
import type { NotificationSettings } from '../NotificationBlock/types';

export enum AutomationSectionType {
	TRIGGER = 'TRIGGER',
	ACTION = 'ACTION',
}

export const OPTION_TYPES: (
	| FilterOptionType
	| typeof FILTER_OPTIONS_DIVIDER
)[] = [
	FilterOptionType.NATIVE_TYPE,
	FilterOptionType.INTEGRATION,
	FilterOptionType.RELATED,
	FILTER_OPTIONS_DIVIDER,
	FilterOptionType.TITLE,
	FilterOptionType.DESCRIPTION,
	FilterOptionType.TAGS,
	FilterOptionType.QUESTION_STATUS,
	FilterOptionType.QUESTION_PRIORITY,
	FilterOptionType.PUBLISHED,
	FilterOptionType.COLLECTIONS,
	FilterOptionType.OWNERS,
	FilterOptionType.PII,
	FilterOptionType.VERIFICATION,
	FilterOptionType.TEAMS,
	FilterOptionType.DATA_QUALITY,
	FilterOptionType.SLACK_CHANNELS,
	FILTER_OPTIONS_DIVIDER,
	FilterOptionType.CREATED_TIME,
	FilterOptionType.UPDATED_TIME,
	FilterOptionType.EXTERNALLY_UPDATED_TIME,
	FILTER_OPTIONS_DIVIDER,
	FilterOptionType.SOURCES,
	FilterOptionType.PARENT_ID,
	FilterOptionType.SCHEMA,
	FilterOptionType.DATABASE,
	FilterOptionType.TABLE,
	FilterOptionType.SCHEMA_NAME,
	FilterOptionType.QUALITY_FLAGS,
	FilterOptionType.TABLE_NAME,
	FILTER_OPTIONS_DIVIDER,
	FilterOptionType.IS_TESTED,
	FilterOptionType.TESTS_PASSING,
	FilterOptionType.IS_MONITORED,
	FilterOptionType.MONITORS_PASSING,
	FILTER_OPTIONS_DIVIDER,
	FilterOptionType.LINEAGE,
	FILTER_OPTIONS_DIVIDER,
	FilterOptionType.POPULARITY,
	FILTER_OPTIONS_DIVIDER,
	FilterOptionType.ANY_CHILD,
	FilterOptionType.ALL_CHILDREN,
	FilterOptionType.NO_CHILDREN,
];

export const DEFAULT_NOTIFICATION_SETTINGS: NotificationSettings = {
	message: undefined,
	subject: undefined,
	includeSummary: false,
	channels: [],
	recipients: [],
};

export const DEFAULT_PROPAGATE_METADATA_SETTINGS: PropagateMetadataSettings = {
	overrideExistingProperties: false,
	properties: [],
	propagateTo: AutomationPropagateMetadataRelationship.CHILDREN,
	level: '1',
};

export const DEFAULT_FILTER_SETTINGS: CatalogRule = {
	operator: 'and',
	operands: [],
};

export enum AutomationSectionGroupNames {
	TRIGGER = 'TRIGGER',
	ACTION = 'ACTION',
	NOTIFICATION = 'NOTIFICATION',
}
